import React from "react";
import {SubHeader} from "../../Containers/SubHeader";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CustomTable, {useHiddenColumns} from "../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import {getComparator, stableSort} from "../Utils/Tables/sortingFunctions";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import * as snackbarActions from "../../actions/snackbarActions"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import MainSnackbar from "../Utils/Snackbar/SmsSnackbar";
import PageTitle from "../Utils/smsTitle";
import {faBed} from "@fortawesome/free-solid-svg-icons/faBed";
import {useBedAssignList} from "./CustomHooks/useBedAssignList";
import {formatDateTime} from "../Utils/ConvertDate";
import {Container} from "../Utils/styledComponents";
import { ReusableRouteTabs } from "../Utils/Dialogs/ReusableTabs";
import { history } from "../../Helpers/history";
import {ConfirmationDialog} from "../Utils/ReusableComponents/ConfirmationDialog";
import CustomDialog from "../Utils/Dialogs/CustomDialog";
import BedTransfer from "./BedTransfer";


const headData = [{id: 'count', numeric: false, disablePadding: false, label: 'SL', hidden:false},
    {id: 'patient_admission_id', numeric: false, disablePadding: false, label: 'Admission Id',hidden:false},
    {id: 'admitted_by', numeric: false, disablePadding: false, label: 'Admitted By',hidden:false},
    {id: 'provider_name', numeric: false, disablePadding: false, label: 'Provider Name',hidden:false},
    {id: 'patient_number', numeric: false, disablePadding: false, label: 'Patient No.',hidden:false},
    {id: 'patient_name', numeric: false, disablePadding: false, label: 'Patient Name',hidden:false},
    {id: 'dob', numeric: false, disablePadding: false, label: 'D.O.B',hidden:false},
    {id: 'phone_no', numeric: false, disablePadding: false, label: 'Phone',hidden:false},
    {id: 'kin_phone', numeric: false, disablePadding: false, label: 'NOK Phone',hidden:false},
    {id: 'assign_date', numeric: false, disablePadding: false, label: 'Assign Date',hidden:false},
    {id: 'ward_name', numeric: false, disablePadding: false, label: 'Ward',hidden:false},
    {id: 'room_name', numeric: false, disablePadding: false, label: 'Room',hidden:false},
    {id: 'bed_number', numeric: false, disablePadding: false, label: 'Bed NO',hidden:false},
    {id: 'action', numeric: false, disablePadding: true, label: 'Action',hidden:false},
];

const BedAssignList = ({actions,snackbars}) => {

    const {searchValue, order, orderBy,  data,  activePage,handleSearch,
            handleRequestSort, handleChangeNewPage,
            closeSnackBar,  isLoading, isSuccess, isError, transferProps} = useBedAssignList(actions, 'cbedmanager/bed_assign_list', 1)

    const  {openConfirmation,  handleCloseConfirmation,handleBillRoom,
        admission_no, showNumber, patientNumbers, state, submitted, rooms, wards,
        bedList, ward_name, room_name, bed_name, to_bed, to_ward, to_room,
        handleChangeRoom, handleChangeWard, handleChangeBed, currencyDetails,
        handleChangeToWard, handleChangeToRoom, changeToBed, handleChange, handleChangePatientNumbers,
        handleClickPatientNumber, handleSubmit, handleReset,
        isSubmitted,patient_name, open, handleCloseDialogForm,handleOpenDialogForm,
    } = transferProps

    const {openBar, type, message} = snackbars;

    const patients = !data.bed_assign ? [] : data.bed_assign;
    const count = !data.total_count ? 0 : data.total_count;

    const {
        headCells, all_hidden, handleAllHeadCells, handleHeadCells
    } = useHiddenColumns(headData);

    const admissions = patients.map((item, index)=>{
        const count = ((activePage - 1) * 10) + index + 1;
        return {
            ...item,
            count,
            date:item.admission_date ? formatDateTime(item.admission_date) : '',
            patient_name:`${!item.first_name ? "" : item.first_name} ${!item.last_name ? "" : item.last_name}`,
            admitted_by: `${!item.admitted_by_first_name ? "" : item.admitted_by_first_name} ${!item.admitted_by_last_name ? "" : item.admitted_by_last_name}`,
            action:(
                <button onClick={()=>handleOpenDialogForm(item.patient_admission_id)} className="btn btn-sm sms-info-btn mr-1 mb-1">Transfer</button>

            )
        }
    })

    const components = [{label: 'Admissions without beds', path: '/unassignedbeds'},
    {label: 'Admissions with beds', path: '/bedassignlist'},
        {label: 'Previous bed assignments', path: '/previousbedassignlist'}]

    return (
        <div data-testid="bed-assign-list" className='journals'>
            <PageTitle title="Admissions with beds"/>
            <SubHeader title="Ward Manager" subTitle="Admissions with beds">
                <FontAwesomeIcon icon={faBed}/>
            </SubHeader>
            <ConfirmationDialog open={openConfirmation} handleClose={handleCloseConfirmation}
                                title='Make cash payment'
                                confirmItems={handleBillRoom}
                                removeItems={handleCloseConfirmation} service='room'/>

            <CustomDialog open={open} handleClose={handleCloseDialogForm} title="Bed Transfer" maxWidth='lg'>
                <BedTransfer state={state} beds={bedList} handleChange={handleChange} submitted={submitted} isSubmitted={isSubmitted}
                             options={wards.map(wd=>({value:wd.ward_id, label:wd.name}))} patientNumbers={patientNumbers} handleClickPatientNumber={handleClickPatientNumber}
                             p_number={admission_no} handleChangePatientNumbers={handleChangePatientNumbers} showNumber={showNumber}
                             changeBed={handleChangeBed} changeRoom={handleChangeRoom} rooms={rooms.map(rm=>({value:rm.room_id, label:rm.name}))} changeWard={handleChangeWard}
                             handleSubmitForm={handleSubmit} bed_number={bed_name} handleResetForm={handleReset} text="Bed transfer" currencyDetails={currencyDetails}
                             title="Bed Transfer" room={room_name} ward={ward_name} to_bed={to_bed} to_ward={to_ward} to_room={to_room}
                             handleChangeToWard={handleChangeToWard} handleChangeToRoom={handleChangeToRoom}
                             handleChangeToBed={changeToBed} patient_name={patient_name}/>

            </CustomDialog>
                <MainSnackbar variant={type} message={message} open={openBar} handleCloseBar={closeSnackBar}/>
            <Container>
                <ReusableRouteTabs value={history.location.pathname} tabHeading={components}/>
                <CustomTable  headData={headCells} handler={handleSearch} term={searchValue}
                             handleRequestSort={handleRequestSort} data={patients} colSpan={headCells.length} order={order}
                             orderBy={orderBy} customPage records={10} activePage={activePage}
                             handleChangeNextPage={handleChangeNewPage} total_count={count}
                              {...{all_hidden, handleAllHeadCells, handleHeadCells}}>
                        <TableBody>
                            {isLoading ? <TableRow>
                                <TableCell colSpan={headCells.length} align="center"><img src="/images/smsloader.gif"
                                                                   alt="loader"/></TableCell>
                                </TableRow>:null}
                            {isSuccess ? admissions.length > 0 ?  stableSort(admissions, getComparator(order, orderBy))
                                .slice(0, 10)
                                .map((item) => {
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={item.bed_assignment_id}
                                            className='mui-table-row'>
                                            {headCells.map((head)=>(
                                                <TableCell id={head.id}  key={head.id}
                                                           hidden={head.hidden}>{item[head.id]}</TableCell>
                                            ))}
                                        </TableRow>
                                    );
                                }):<TableRow>
                                <TableCell colSpan={headCells.length} align="center">No records found</TableCell>
                            </TableRow>:null}
                            {isError ? <TableRow>
                                <TableCell colSpan={headCells.length} align="center">The server did not return a valid response</TableCell>
                            </TableRow>:null}
                        </TableBody>
                </CustomTable>
            </Container>
        </div>
    )
};

function mapStateToProps(state) {
    return {snackbars: state.snackbar}
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BedAssignList);
